import WeatherReportSummaryCard from "./WeatherReportSummaryCard";
import WeatherReportEvidenceSection from "./WeatherReportEvidenceSection";
import WeatherReportSourceStatus from "./WeatherReportSourceStatus";
import WeatherReportRecommendations from "./WeatherReportRecommendations";
import WeatherReportExportButton from "./WeatherReportExportButton";

export default function WeatherIntelligenceReport({
  reportPayload,
  loading = false,
  errorMessage = "",
  title = "Weather intelligence report",
}) {
  if (loading) {
    return <p className="muted">Generating report…</p>;
  }

  if (errorMessage) {
    return <p className="muted">{errorMessage}</p>;
  }

  if (!reportPayload?.available) {
    return (
      <section className="panel-card weather-intelligence-report weather-intelligence-report--empty">
        <p className="eyebrow">{title}</p>
        <p className="muted">{reportPayload?.message || "Report unavailable."}</p>
      </section>
    );
  }

  const report = reportPayload.report;

  return (
    <article id="weather-intelligence-report" className="weather-intelligence-report">
      <header className="weather-intelligence-report__header">
        <div>
          <p className="eyebrow">{title}</p>
          <h2>Client weather intelligence</h2>
          <p className="muted">
            Generated {report.meta?.generatedAt ? new Date(report.meta.generatedAt).toLocaleString() : ""}
          </p>
        </div>
        <WeatherReportExportButton />
      </header>

      <WeatherReportSummaryCard summary={report.summary} />
      <WeatherReportSourceStatus sourceStatus={report.sourceStatus} />
      <WeatherReportEvidenceSection evidence={report.evidence} />
      <WeatherReportRecommendations recommendations={report.recommendations} />

      <section className="panel-card weather-intelligence-report__limitations">
        <p className="eyebrow">Limitations</p>
        <ul className="muted">
          {(report.limitations || []).map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </section>

      {report.attribution?.length ? (
        <section className="panel-card weather-intelligence-report__attribution">
          <p className="eyebrow">Attribution</p>
          <ul className="muted">
            {report.attribution.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </section>
      ) : null}

      <p className="weather-intelligence-report__disclaimer muted" role="note">
        {report.disclaimer}
      </p>
    </article>
  );
}
